export default "__VITE_ASSET__CwJ3MdI$__"